import React, { createContext, useState, useEffect } from 'react';
import { getDeviceSettings } from '../core/apis/mykeys/configuration';
import { MyKeysPromiseMap } from '../core/apis/mykeys/mappings';

export interface ServerSettings {
  products: string[];
}

type ISettings = {
  settings: ServerSettings;
  setSettings: (settings: ServerSettings) => void;
};

const defaultState = {
  products: [] as string[],
};

export const SettingsCtx = createContext({} as ISettings);

export const SettingsProvider = ({ children }: any) => {
  const [settings, setSettings] = useState(defaultState);
  useEffect(() => {
    getDeviceSettings()
      .then(MyKeysPromiseMap)
      .then((data) => setSettings(data));
  }, []);

  return (
    <SettingsCtx.Provider value={{ settings, setSettings }}>
      {children}
    </SettingsCtx.Provider>
  );
};
